import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/user-34.jpg'
import _imports_1 from '@/assets/images/user-35.jpg'
import _imports_2 from '@/assets/images/user-36.jpg'


export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("ul", {
      class: "nav nav-tabs review-tabs gap-3 border-0 bg-transparent",
      id: "myTab",
      role: "tablist"
    }, [
      _createElementVNode("li", {
        class: "nav-item",
        role: "presentation"
      }, [
        _createElementVNode("button", {
          class: "nav-link border-0 fs-16 fw-medium active",
          id: "description-tab",
          "data-bs-toggle": "tab",
          "data-bs-target": "#description-tab-pane",
          type: "button",
          role: "tab",
          "aria-controls": "description-tab-pane",
          "aria-selected": "true"
        }, " Description ")
      ]),
      _createElementVNode("li", {
        class: "nav-item",
        role: "presentation"
      }, [
        _createElementVNode("button", {
          class: "nav-link border-0 fs-16 fw-medium",
          id: "specification-tab",
          "data-bs-toggle": "tab",
          "data-bs-target": "#specification-tab-pane",
          type: "button",
          role: "tab",
          "aria-controls": "specification-tab-pane",
          "aria-selected": "false"
        }, " Specification ")
      ]),
      _createElementVNode("li", {
        class: "nav-item",
        role: "presentation"
      }, [
        _createElementVNode("button", {
          class: "nav-link border-0 fs-16 fw-medium",
          id: "reviews-tab",
          "data-bs-toggle": "tab",
          "data-bs-target": "#reviews-tab-pane",
          type: "button",
          role: "tab",
          "aria-controls": "reviews-tab-pane",
          "aria-selected": "false"
        }, " Reviews ")
      ])
    ], -1),
    _createElementVNode("div", {
      class: "tab-content",
      id: "myTabContent"
    }, [
      _createElementVNode("div", {
        class: "tab-pane fade show active",
        id: "description-tab-pane",
        role: "tabpanel",
        "aria-labelledby": "description-tab",
        tabindex: "0"
      }, [
        _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4 rounded-top-0" }, [
          _createElementVNode("div", { class: "card-body p-4" }, [
            _createElementVNode("p", null, " The Apple MacBook Pro 16.2 is a cutting-edge laptop designed to deliver exceptional performance and advanced features for professionals and creative enthusiasts. With its sleek aluminum body and precision engineering, this MacBook Pro represents the pinnacle of Apple's laptop technology. "),
            _createElementVNode("p", null, " Stay connected with a variety of ports, including Thunderbolt 3, USB-C, and audio jacks. These versatile ports support high-speed data transfer and external device connections. Enjoy a rich audio experience with high-fidelity speakers that deliver clear and immersive sound. Perfect for content creators and multimedia enthusiasts. "),
            _createElementVNode("p", null, " Equipped with the latest processors, ample RAM, and high-performance graphics, the MacBook Pro 16.2 ensures smooth multitasking, fast rendering, and efficient handling of resource-intensive tasks. Seamlessly integrate with the macOS ecosystem, benefiting from features like iCloud, Siri, and a vast selection of applications available on the App Store. ")
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: "tab-pane fade",
        id: "specification-tab-pane",
        role: "tabpanel",
        "aria-labelledby": "specification-tab",
        tabindex: "0"
      }, [
        _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4 rounded-top-0" }, [
          _createElementVNode("div", { class: "card-body p-4" }, [
            _createElementVNode("div", { class: "default-table-area style-two" }, [
              _createElementVNode("div", { class: "table-responsive p-0" }, [
                _createElementVNode("table", { class: "table table-bordered" }, [
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", { class: "title text-dark" }, "Brand"),
                      _createElementVNode("td", { class: "price" }, "Apple")
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", { class: "title text-dark" }, "Categories"),
                      _createElementVNode("td", { class: "price" }, "Brond New")
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", { class: "title text-dark" }, "SKU"),
                      _createElementVNode("td", { class: "price" }, "01")
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", { class: "title text-dark" }, "Price"),
                      _createElementVNode("td", { class: "price" }, "$399")
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", {
        class: "tab-pane fade",
        id: "reviews-tab-pane",
        role: "tabpanel",
        "aria-labelledby": "reviews-tab",
        tabindex: "0"
      }, [
        _createElementVNode("div", { class: "card bg-white border-0 rounded-3 mb-4 rounded-top-0" }, [
          _createElementVNode("div", { class: "card-body p-4" }, [
            _createElementVNode("div", { class: "mw-480 text-center m-auto mb-4" }, [
              _createElementVNode("h3", { class: "fs-24" }, "Feedback"),
              _createElementVNode("p", null, " This is a wider card with supporting text below as a natural lead-in to additional content. ")
            ]),
            _createElementVNode("div", { class: "row justify-content-center" }, [
              _createElementVNode("div", { class: "col-xl-4 col-sm-6 col-md-6" }, [
                _createElementVNode("div", { class: "card bg-body-bg border-0 rounded-3 mb-4" }, [
                  _createElementVNode("div", { class: "card-body p-4" }, [
                    _createElementVNode("ul", { class: "ps-0 mb-2 list-unstyled d-flex gap-2" }, [
                      _createElementVNode("li", null, [
                        _createElementVNode("i", { class: "ri-star-fill text-warning fs-20" })
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("i", { class: "ri-star-fill text-warning fs-20" })
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("i", { class: "ri-star-fill text-warning fs-20" })
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("i", { class: "ri-star-fill text-warning fs-20" })
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("i", { class: "ri-star-line text-light fs-20" })
                      ])
                    ]),
                    _createElementVNode("p", { class: "fw-medium" }, " This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit. "),
                    _createElementVNode("div", { class: "d-flex align-items-center mt-3" }, [
                      _createElementVNode("div", { class: "flex-shrink-0" }, [
                        _createElementVNode("img", {
                          src: _imports_0,
                          class: "rounded-circle wh-35",
                          alt: "user"
                        })
                      ]),
                      _createElementVNode("div", { class: "flex-grow-1 ms-3" }, [
                        _createElementVNode("h4", { class: "mb-0 fs-16 fw-medium" }, "Alvarado Turner")
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", { class: "col-xl-4 col-sm-6 col-md-6" }, [
                _createElementVNode("div", { class: "card bg-body-bg border-0 rounded-3 mb-4" }, [
                  _createElementVNode("div", { class: "card-body p-4" }, [
                    _createElementVNode("ul", { class: "ps-0 mb-2 list-unstyled d-flex gap-2" }, [
                      _createElementVNode("li", null, [
                        _createElementVNode("i", { class: "ri-star-fill text-warning fs-20" })
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("i", { class: "ri-star-fill text-warning fs-20" })
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("i", { class: "ri-star-fill text-warning fs-20" })
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("i", { class: "ri-star-fill text-warning fs-20" })
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("i", { class: "ri-star-line text-light fs-20" })
                      ])
                    ]),
                    _createElementVNode("p", { class: "fw-medium" }, " This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit. "),
                    _createElementVNode("div", { class: "d-flex align-items-center mt-3" }, [
                      _createElementVNode("div", { class: "flex-shrink-0" }, [
                        _createElementVNode("img", {
                          src: _imports_1,
                          class: "rounded-circle wh-35",
                          alt: "user"
                        })
                      ]),
                      _createElementVNode("div", { class: "flex-grow-1 ms-3" }, [
                        _createElementVNode("h4", { class: "mb-0 fs-16 fw-medium" }, "Eddie Bryan")
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", { class: "col-xl-4 col-sm-6 col-md-6" }, [
                _createElementVNode("div", { class: "card bg-body-bg border-0 rounded-3 mb-4" }, [
                  _createElementVNode("div", { class: "card-body p-4" }, [
                    _createElementVNode("ul", { class: "ps-0 mb-2 list-unstyled d-flex gap-2" }, [
                      _createElementVNode("li", null, [
                        _createElementVNode("i", { class: "ri-star-fill text-warning fs-20" })
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("i", { class: "ri-star-fill text-warning fs-20" })
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("i", { class: "ri-star-fill text-warning fs-20" })
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("i", { class: "ri-star-fill text-warning fs-20" })
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("i", { class: "ri-star-fill text-warning fs-20" })
                      ])
                    ]),
                    _createElementVNode("p", { class: "fw-medium" }, " This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit. "),
                    _createElementVNode("div", { class: "d-flex align-items-center mt-3" }, [
                      _createElementVNode("div", { class: "flex-shrink-0" }, [
                        _createElementVNode("img", {
                          src: _imports_2,
                          class: "rounded-circle wh-35",
                          alt: "user"
                        })
                      ]),
                      _createElementVNode("div", { class: "flex-grow-1 ms-3" }, [
                        _createElementVNode("h4", { class: "mb-0 fs-16 fw-medium" }, "Thomas Albart")
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("h3", { class: "fs-18 fw-semibold mb-4" }, "Customers Feedback :"),
            _createElementVNode("div", { class: "card bg-body-bg border-0 rounded-3 mb-4" }, [
              _createElementVNode("div", { class: "card-body p-4" }, [
                _createElementVNode("div", { class: "row align-items-center" }, [
                  _createElementVNode("div", { class: "col-lg-8" }, [
                    _createElementVNode("div", { class: "d-flex align-items-center mb-3" }, [
                      _createElementVNode("ul", { class: "pe-4 mb-0 list-unstyled d-flex gap-2" }, [
                        _createElementVNode("li", null, [
                          _createElementVNode("i", { class: "ri-star-fill text-warning fs-20" })
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("i", { class: "ri-star-fill text-warning fs-20" })
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("i", { class: "ri-star-fill text-warning fs-20" })
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("i", { class: "ri-star-fill text-warning fs-20" })
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("i", { class: "ri-star-fill text-warning fs-20" })
                        ])
                      ]),
                      _createElementVNode("div", {
                        class: "progress w-100 rounded-pill",
                        role: "progressbar",
                        "aria-label": "Example 5px high",
                        "aria-valuenow": "100",
                        "aria-valuemin": "0",
                        "aria-valuemax": "100",
                        style: {"height":"5px","background-color":"#eff2ff"}
                      }, [
                        _createElementVNode("div", {
                          class: "progress-bar rounded-pill",
                          style: {"width":"100%"}
                        })
                      ]),
                      _createElementVNode("span", { class: "ms-4" }, "359")
                    ]),
                    _createElementVNode("div", { class: "d-flex align-items-center mb-3" }, [
                      _createElementVNode("ul", { class: "pe-4 mb-0 list-unstyled d-flex gap-2" }, [
                        _createElementVNode("li", null, [
                          _createElementVNode("i", { class: "ri-star-fill text-warning fs-20" })
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("i", { class: "ri-star-fill text-warning fs-20" })
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("i", { class: "ri-star-fill text-warning fs-20" })
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("i", { class: "ri-star-fill text-warning fs-20" })
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("i", { class: "ri-star-line text-gray-light fs-20" })
                        ])
                      ]),
                      _createElementVNode("div", {
                        class: "progress w-100 rounded-pill",
                        role: "progressbar",
                        "aria-label": "Example 5px high",
                        "aria-valuenow": "90",
                        "aria-valuemin": "0",
                        "aria-valuemax": "100",
                        style: {"height":"5px","background-color":"#eff2ff"}
                      }, [
                        _createElementVNode("div", {
                          class: "progress-bar rounded-pill",
                          style: {"width":"90%"}
                        })
                      ]),
                      _createElementVNode("span", { class: "ms-4" }, "208")
                    ]),
                    _createElementVNode("div", { class: "d-flex align-items-center mb-3" }, [
                      _createElementVNode("ul", { class: "pe-4 mb-0 list-unstyled d-flex gap-2" }, [
                        _createElementVNode("li", null, [
                          _createElementVNode("i", { class: "ri-star-fill text-warning fs-20" })
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("i", { class: "ri-star-fill text-warning fs-20" })
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("i", { class: "ri-star-fill text-warning fs-20" })
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("i", { class: "ri-star-line text-gray-light fs-20" })
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("i", { class: "ri-star-line text-gray-light fs-20" })
                        ])
                      ]),
                      _createElementVNode("div", {
                        class: "progress w-100 rounded-pill",
                        role: "progressbar",
                        "aria-label": "Example 5px high",
                        "aria-valuenow": "80",
                        "aria-valuemin": "0",
                        "aria-valuemax": "100",
                        style: {"height":"5px","background-color":"#eff2ff"}
                      }, [
                        _createElementVNode("div", {
                          class: "progress-bar rounded-pill",
                          style: {"width":"80%"}
                        })
                      ]),
                      _createElementVNode("span", { class: "ms-4" }, "124")
                    ]),
                    _createElementVNode("div", { class: "d-flex align-items-center mb-3" }, [
                      _createElementVNode("ul", { class: "pe-4 mb-0 list-unstyled d-flex gap-2" }, [
                        _createElementVNode("li", null, [
                          _createElementVNode("i", { class: "ri-star-fill text-warning fs-20" })
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("i", { class: "ri-star-fill text-warning fs-20" })
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("i", { class: "ri-star-line text-gray-light fs-20" })
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("i", { class: "ri-star-line text-gray-light fs-20" })
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("i", { class: "ri-star-line text-gray-light fs-20" })
                        ])
                      ]),
                      _createElementVNode("div", {
                        class: "progress w-100 rounded-pill",
                        role: "progressbar",
                        "aria-label": "Example 5px high",
                        "aria-valuenow": "70",
                        "aria-valuemin": "0",
                        "aria-valuemax": "100",
                        style: {"height":"5px","background-color":"#eff2ff"}
                      }, [
                        _createElementVNode("div", {
                          class: "progress-bar rounded-pill",
                          style: {"width":"70%"}
                        })
                      ]),
                      _createElementVNode("span", { class: "ms-4" }, "89")
                    ]),
                    _createElementVNode("div", { class: "d-flex align-items-center mb-0" }, [
                      _createElementVNode("ul", { class: "pe-4 mb-0 list-unstyled d-flex gap-2" }, [
                        _createElementVNode("li", null, [
                          _createElementVNode("i", { class: "ri-star-fill text-warning fs-20" })
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("i", { class: "ri-star-line text-gray-light fs-20" })
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("i", { class: "ri-star-line text-gray-light fs-20" })
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("i", { class: "ri-star-line text-gray-light fs-20" })
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("i", { class: "ri-star-line text-gray-light fs-20" })
                        ])
                      ]),
                      _createElementVNode("div", {
                        class: "progress w-100 rounded-pill",
                        role: "progressbar",
                        "aria-label": "Example 5px high",
                        "aria-valuenow": "60",
                        "aria-valuemin": "0",
                        "aria-valuemax": "100",
                        style: {"height":"5px","background-color":"#eff2ff"}
                      }, [
                        _createElementVNode("div", {
                          class: "progress-bar rounded-pill",
                          style: {"width":"60%"}
                        })
                      ]),
                      _createElementVNode("span", { class: "ms-4" }, "4")
                    ])
                  ]),
                  _createElementVNode("div", { class: "col-lg-4" }, [
                    _createElementVNode("div", { class: "text-center mt-4 mt-lg-0" }, [
                      _createElementVNode("h1", { class: "fs-40 mb-2" }, "4.28"),
                      _createElementVNode("ul", { class: "ps-0 mb-3 list-unstyled d-flex gap-2 justify-content-center" }, [
                        _createElementVNode("li", null, [
                          _createElementVNode("i", { class: "ri-star-fill text-warning fs-30" })
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("i", { class: "ri-star-fill text-warning fs-30" })
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("i", { class: "ri-star-fill text-warning fs-30" })
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("i", { class: "ri-star-fill text-warning fs-30" })
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("i", { class: "ri-star-line text-light fs-30" })
                        ])
                      ]),
                      _createElementVNode("span", { class: "ms-4" }, "of 3250 Reviews")
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", { class: "d-sm-flex justify-content-between align-items-center mb-4" }, [
              _createElementVNode("h3", { class: "fs-18 fw-semibold text-center" }, " Write Feedback Here: "),
              _createElementVNode("ul", { class: "ps-0 mb-0 list-unstyled d-flex gap-2 justify-content-center ratings" }, [
                _createElementVNode("li", { class: "rating" }, [
                  _createElementVNode("i", { class: "ri-star-fill fs-20" })
                ]),
                _createElementVNode("li", { class: "rating" }, [
                  _createElementVNode("i", { class: "ri-star-fill fs-20" })
                ]),
                _createElementVNode("li", { class: "rating" }, [
                  _createElementVNode("i", { class: "ri-star-fill fs-20" })
                ]),
                _createElementVNode("li", { class: "rating" }, [
                  _createElementVNode("i", { class: "ri-star-fill fs-20" })
                ]),
                _createElementVNode("li", { class: "rating" }, [
                  _createElementVNode("i", { class: "ri-star-fill fs-20" })
                ])
              ])
            ]),
            _createElementVNode("div", { class: "card bg-body-bg border-0 rounded-3 mb-4" }, [
              _createElementVNode("div", { class: "card-body p-4" }, [
                _createElementVNode("form", null, [
                  _createElementVNode("div", { class: "row" }, [
                    _createElementVNode("div", { class: "col-lg-6" }, [
                      _createElementVNode("div", { class: "form-group mb-4" }, [
                        _createElementVNode("label", { class: "label text-secondary" }, "Your Name"),
                        _createElementVNode("input", {
                          type: "text",
                          class: "form-control h-55 text-dark",
                          placeholder: "Your Name"
                        })
                      ])
                    ]),
                    _createElementVNode("div", { class: "col-lg-6" }, [
                      _createElementVNode("div", { class: "form-group mb-4" }, [
                        _createElementVNode("label", { class: "label text-secondary" }, "Your Email"),
                        _createElementVNode("input", {
                          type: "email",
                          class: "form-control h-55 text-dark",
                          placeholder: "Your Email"
                        })
                      ])
                    ]),
                    _createElementVNode("div", { class: "col-lg-6" }, [
                      _createElementVNode("div", { class: "form-group mb-4" }, [
                        _createElementVNode("label", { class: "label text-secondary" }, "Your Phone No"),
                        _createElementVNode("input", {
                          type: "number",
                          class: "form-control h-55 text-dark",
                          placeholder: "Your Phone No"
                        })
                      ])
                    ]),
                    _createElementVNode("div", { class: "col-lg-6" }, [
                      _createElementVNode("div", { class: "form-group mb-4" }, [
                        _createElementVNode("label", { class: "label text-secondary" }, "Your Subject"),
                        _createElementVNode("input", {
                          type: "email",
                          class: "form-control h-55 text-dark",
                          placeholder: "Your Subject"
                        })
                      ])
                    ]),
                    _createElementVNode("div", { class: "col-lg-12" }, [
                      _createElementVNode("div", { class: "form-group mb-4" }, [
                        _createElementVNode("label", { class: "label text-secondary" }, " Write Comment "),
                        _createElementVNode("textarea", {
                          class: "form-control",
                          placeholder: "Write Comment",
                          cols: "30",
                          rows: "10"
                        })
                      ])
                    ]),
                    _createElementVNode("div", { class: "col-lg-12" }, [
                      _createElementVNode("div", { class: "form-group mb-0" }, [
                        _createElementVNode("button", {
                          type: "submit",
                          class: "btn btn-primary text-white fw-semibold py-3 px-5"
                        }, " Submit ")
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ], -1)
  ]))]))
}